import React from 'react';
import './Header.css';
import './bootstrap.min.css';
import { Link } from 'react-router-dom';
import { useStateValue } from "./StateProvider";
import { auth } from './firebase';

function Header() {
    const [{ basket, user }, dispatch] = useStateValue();

    const handleAuthentication = () => {
        if (user) {
            auth.signOut();
        }
    }
    // console.log(basket);

    return (
    <div className="sticky">
        <div className="container-fluid">
            <div className="row">
                <nav className="bar">
                    <Link to="/">
                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 logo">
                            <img src={'/images/logo.png'} alt=""/>
                        </div>
                    </Link>

                    <div className="col-xs-3 col-sm-5
                    col-md-5 col-lg-7 search">
                        <input type="text"/>
                        <i className="fa fa-search"></i>
                    </div>      

                    <div className="col-xs-3 col-sm-4 col-md-4 col-lg-3 links">
                        <Link className="link" to={!user && '/login'}>
                            <div className="option" onClick={handleAuthentication}>
                                <span>Hello {!user ? 'Guest' : user.email}</span>
                                <span><b>{user ? 'Sign Out' : 'Sign In'}</b>
                                </span>
                              </div>
                        </Link> 
                    
                        <Link className="link" to="/orders">
                            <div className="option">
                                <span>Returns</span>
                                <span><b>& Orders</b></span>
                            </div>
                        </Link>

                        <Link className="link" 
                        to="/checkout">
                            <div className="option3">
                                <i class="fa fa-cart-plus">
                                </i>
                                <h2>{basket?.length}</h2>
                            </div>
                        </Link>
                    </div>
                </nav>
            </div>
        </div>
    </div>
    )
}

export default Header;
